// import guid from '@/lib/guid';
const table = 'charts';
import {db} from '@/services/db.js';
import {createGrid} from '@/models/grid';
import {createLayout} from '@/models/layout';
import Element from '@/models/chart-element'
import LayoutElement from '@/models/chart-layout-element'
import {loadParameter, loadHydrator} from '@/components/charts/';
import ApiService from '@/services/api.service';
import {chartTypes} from '@/components/charts';
import themes from '@/themes/themes';
import {encode, decode} from '@/lib/common';

// console.log("themes", themes);

function resolve(path, obj) {
    return path.split('.').reduce(function(prev, curr) {
        return prev ? prev[curr] : null
    }, obj || self)
}




export function create(data) {
  if(typeof data != "undefined" && typeof data.typeGroup != "undefined" && data.typeGroup == "board") {
    return new LayoutElement(data);
  } else {
    return new Element(data);
  }
}


// function encode(data) {
//   return window.btoa(JSON.stringify(data));
// }

// function decode(data) {
//   return JSON.parse(window.atob(data));
// }

function prepareApiInput(chart, resetId) {
  return chart.getApiInput(resetId);
}

export async function get(params) {
  // console.log('datasource table', table);
  try {
    // const response = await ApiService.query('/element/search/findByProjectId', {params: params});

    const response = await ApiService.query('/chart/list/' + params.projectId + "/" + params.typeGroup, {});

    return hydrateApiResult(response.data);
    //return hydrateDataSources(await db[table].where("projectId").equals(projectId).toArray());
  } catch (err) {
    return [];
  }
}

export async function getChart(id) {
  // console.log('datasource table', table);
  try {
    const response = await ApiService.query('/chart/' + id, {});
    return hydrate(response.data);
  } catch (err) {
    return [];
  }
}


export async function add(element) {
  const payload = prepareApiInput(element);
  const response = await ApiService.post('/element', payload);
  return hydrate(response.data);
}

export async function addUsingPayload(payload) {
  if(typeof payload.id != "undefined") {
    delete payload.id;
  }
  const response = await ApiService.post('/element', payload);
  return hydrate(response.data);
}

export async function updateUsingPayload(payload, id) {
  if(typeof payload.id != "undefined") {
    delete payload.id;
  }
  return await ApiService.update('/element', id, payload);
}



export async function getExport(element) {
  const payload = prepareApiInput(element);
  return payload;
  // console.log("payload", decode(payload.schema));
}

export function download(chart) {

  const json  = prepareApiInput(chart);
  // Convert Object to JSON
  const jsonString = JSON.stringify(json);
  const exportedFilenmae = chart.name + ".json";

  const blob = new Blob([jsonString], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilenmae);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilenmae);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

export async function duplicate(element) {
  const payload = prepareApiInput(element, true);

  payload.name = payload.name + " Copy";
  // console.log("payload", payload);
  

  // // console.log("payload", decode(payload.schema));
  delete payload.id;
  return await ApiService.post('/element', payload);
}


export async function update(element) {
  const payload = prepareApiInput(element);
  // console.log("payload", decode(payload.schema));
  delete payload.id;
  return await ApiService.update('/element', element.id, payload);
}

export async function remove(element) {
    return await ApiService.delete('/element/' + element.id);
   // return await db[table].delete(dataSource.id)
}

export function hydrate(element) {
  // console.log("calling hydrate");
  
  try {
    element.schema = decode(element.schema);
    element.content = decode(element.content);
    element.schemaLoaded = true;
  } catch(error) {
    element.schema = {};
    element.content = {};
    element.schemaLoaded = false;
  }
  
  return create(element);
}

export function hydrateApiResult(response) {
  // const elements = response._embedded.element;
  // console.log("elements", elements);
  const elements = response;
  let result = [];
  elements.forEach(function(element) {
    // element.schema = decode(element.schema);
    // element.content = decode(element.content);
    result.push(hydrate(element));
  });
  return result;
}

export async function fetchByProjectId(projectId) {
  try {
    return hydrate(await db[table].where("projectId").equals(projectId).toArray());
  } catch (err) {
    return [];
  }
}

export function initialState() {
  return {
    chart: {},
    subChart: {},
    display: false,
    editable: true,
    projectId: 0,
    charts: [],
    dataSource: [],
    parameterisedFilterObject: {},
    filters: {},
    chartType: null,
    activeGrid: {id: null},
    activeLayer: {id: null, type: null},
    loading: false,
    progressValue: 0,
    chartTypes: chartTypes,
    dialog: false,
    subChartDialog: false,
    showGridMenu: false,
    mode: null,
    themes: themes,
    theme: themes.default,
  };
}


export function getDashboardIndex(user, charts) {
  if(user.modules == "undefined" || !user.modules || !user.modules.length) {
    return 0;
  }
  try {
  if(user.config && user.config.modules && user.config.modules.length) {
      const code = user.config.modules[0];
      const module = user.modules.find(item => item.code == code);
      const index = charts.findIndex(item => item.id == module.dashboardId);
      if(index > -1) {
        return index;
      }
    } 
  } catch {

  }
  return 0;
  
}

export function getACLCharts(user, charts) {
  //  || user.is_admin == true
  // if(user.modules == "undefined" || !user.modules || !user.modules.length) {
  //   return charts;
  // }

  let results = [];
  try {
  if(user.config && user.config.modules && user.config.modules.length) {
      for(let i = 0; i < user.config.modules.length; i++) {
        const module = user.config.modules[i];
        const chart = charts.find(item => item.id == module.dashboardId);
        if(chart) {
          results.push(chart);
        }
      }

    } 
  } catch(error) {
    console.log("getACLCharts", error);
  }
  return results;
  
}

export function setUserModules(pUser) {
  let user = {...pUser};
  user.userModules = [];
  if(typeof user.modules == "undefined" || !user.modules || !user.modules.length) {
    return user;
  }
  try {
  if(user.config && user.config.modules && user.config.modules.length) {
      user.userModules = user.modules.filter(item => user.config.modules.includes(item.code));
    } 
  } catch(error) {
    console.log("getACLCharts", error);
  }
  return user;
}